module.exports = __webpack_public_path__ + "img/pencil-square.94e4d31b.svg";